import { MakeoverIntensity } from "../../../@types/sharedSchema";

/** The "how much to change" levels, ordered lightest → heaviest. */
export const MAKEOVER_INTENSITY_LEVELS: {
  key: MakeoverIntensity;
  labelKey: string;
  labelDefault: string;
  descKey: string;
  descDefault: string;
}[] = [
  {
    key: "tidy",
    labelKey: "makeovers.intensity.tidy",
    labelDefault: "סידור וניקיון",
    descKey: "makeovers.intensity.tidyDesc",
    descDefault: "פינוי בלאגן וסידור בלבד — בלי לשנות ריהוט, ריצוף או עיצוב."
  },
  {
    key: "refresh",
    labelKey: "makeovers.intensity.refresh",
    labelDefault: "רענון קל",
    descKey: "makeovers.intensity.refreshDesc",
    descDefault: "סטיילינג קל, תאורה ונגיעות עיצוב — שומר על הריהוט והגימורים הקיימים."
  },
  {
    key: "restyle",
    labelKey: "makeovers.intensity.restyle",
    labelDefault: "עיצוב מחדש",
    descKey: "makeovers.intensity.restyleDesc",
    descDefault: "ריהוט, צבע ועיצוב חדשים — שומר על הריצוף והאלמנטים הבנויים."
  },
  {
    key: "full",
    labelKey: "makeovers.intensity.full",
    labelDefault: "מייקאובר מלא",
    descKey: "makeovers.intensity.fullDesc",
    descDefault: "עיצוב מלא כולל ריצוף וגימורים — אותו מבנה, פריסה וזווית צילום."
  }
];

export const DEFAULT_MAKEOVER_INTENSITY: MakeoverIntensity = "restyle";
